import Comp from "./AIStarButton";
export default Comp;
